import React, { useEffect } from 'react';

import { useLocation } from 'react-router-dom';

import { useAppSelector } from '@pkg/hooks';

import { YAT_PICKER } from '@app/routes/paths';
import { useAuthTokens, useNavigationStore } from '@app/store/zustand';

import { Icon } from '../SidebarNav/Icon';
import { Emoji } from '../SidebarNav/styles';

import { MobileButton, MobileLink, MobileLinkInside, Wrapper } from './styles';

export const MobileNav = () => {
    const location = useLocation();
    const { isAuthenticated } = useAuthTokens();

    const primaryYat = useAppSelector((state) => state.user?.primaryYat);
    const isRegisteredUser = useAppSelector((state) => state.user.isRegisteredUser);
    const { showDiscoverPage, yatFantasyEnabled } = useAppSelector((state) => state.featureFlags.features);

    const toggleMobileMenu = useNavigationStore((state) => state.toggleMobileMenu);
    const showMobileMenu = useNavigationStore((state) => state.showMobileMenu);

    useEffect(() => {
        if (isAuthenticated) toggleMobileMenu(false);
    }, [isAuthenticated, toggleMobileMenu]);

    return (
        <Wrapper>
            {showDiscoverPage && (
                <MobileLink
                    to="/discover"
                    $isActive={location.pathname.startsWith('/discover') && !showMobileMenu}
                    onClick={() => toggleMobileMenu(false)}
                >
                    <MobileLinkInside>
                        <span>
                            <Icon name="discover" />
                        </span>
                    </MobileLinkInside>
                </MobileLink>
            )}

            {isRegisteredUser && (
                <MobileLink
                    to={`/${primaryYat}`}
                    $isActive={
                        location.pathname.startsWith(`/${encodeURIComponent(primaryYat || '')}`) && !showMobileMenu
                    }
                    onClick={() => toggleMobileMenu(false)}
                >
                    <MobileLinkInside>
                        <span>
                            <Icon name="profile" />
                        </span>
                    </MobileLinkInside>
                </MobileLink>
            )}

            <MobileLink
                to={YAT_PICKER}
                $isActive={location.pathname.startsWith(YAT_PICKER) && !showMobileMenu}
                onClick={() => toggleMobileMenu(false)}
            >
                <MobileLinkInside>
                    <span>
                        <Emoji emojiID="🖖" aria-hidden />
                    </span>
                </MobileLinkInside>
            </MobileLink>

            {yatFantasyEnabled && (
                <MobileLink
                    to="/fantasy"
                    $isActive={location.pathname.startsWith('/fantasy') && !showMobileMenu}
                    onClick={() => toggleMobileMenu(false)}
                >
                    <MobileLinkInside>
                        <span>
                            <Emoji emojiID="🦄" aria-hidden />
                        </span>
                    </MobileLinkInside>
                </MobileLink>
            )}

            <MobileLink
                to="/search"
                $isActive={location.pathname.startsWith('/search') && !showMobileMenu}
                onClick={() => toggleMobileMenu(false)}
            >
                <MobileLinkInside>
                    <span>
                        <Icon name="search" />
                    </span>
                </MobileLinkInside>
            </MobileLink>

            {isRegisteredUser && (
                <MobileLink
                    to="/wishlists"
                    $isActive={location.pathname.startsWith('/wishlists') && !showMobileMenu}
                    onClick={() => toggleMobileMenu(false)}
                >
                    <MobileLinkInside>
                        <span>
                            <Icon name="wishlists" />
                        </span>
                    </MobileLinkInside>
                </MobileLink>
            )}

            <MobileButton onClick={() => toggleMobileMenu(!showMobileMenu)} $isActive={showMobileMenu}>
                <MobileLinkInside>
                    <span>
                        <Icon name="menu" />
                    </span>
                </MobileLinkInside>
            </MobileButton>
        </Wrapper>
    );
};
